import { render, staticRenderFns } from "./AdminTeamTypes.vue?vue&type=template&id=2350a248&scoped=true"
import script from "./AdminTeamTypes.vue?vue&type=script&lang=js"
export * from "./AdminTeamTypes.vue?vue&type=script&lang=js"
import style0 from "./AdminTeamTypes.vue?vue&type=style&index=0&id=2350a248&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2350a248",
  null
  
)

export default component.exports